export { getVehiclesData } from './get-vehicles-data'
